// 收付款 关联 订单金额
<template>
  <div class="clearfix">
    <div class="modal-header sel-modal-header clearfix">
      <vxe-radio-group v-model="cate" size="medium">
        <ul class="tab-list">
          <li @click="changeCate('Collection')" v-if="!showCate">
            <vxe-radio name="xtabs" label="Collection">托运人订单</vxe-radio>
          </li>
          <li @click="changeCate('Payment')" v-if="showCate">
            <vxe-radio name="xtabs" label="Payment">承运人订单</vxe-radio>
          </li>
          <li @click="changeCate('SellerPayment')" v-if="showCate">
            <vxe-radio name="xtabs" label="SellerPayment"
            >实际承运人订单
            </vxe-radio
            >
          </li>
        </ul>
      </vxe-radio-group>
      <div class="my-search">
        <vxe-input
            v-model="searchOrdersNum"
            style="width: 200px"
            type="search"
            placeholder="输入订单号"
            @search-click="search"
            @keyup.enter.native="search"
        ></vxe-input>
        <vxe-input
            v-model="searchOrdersName"
            type="search"
            :placeholder="
            cate === 'Collection'
              ? '请输入托运人名称'
              : cate === 'Payment'
              ? '请输入承运人名称'
              : '请输入实际承运人名称'
          "
            @search-click="search"
            @keyup.enter.native="search"
            style="width: 200px; margin-left: 20px"
        ></vxe-input>
      </div>
    </div>

    <div class="add-box clearfix">
      <vxe-table
          show-overflow
          stripe
          highlight-current-row
          border="none"
          class="table-style"
          ref="xTable"
          max-height="450"
          :auto-resize="true"
          :data="tableData"
          align="center"
          @current-change="currentChangeEvent"
      >
        <!-- <vxe-table-column
          type="checkbox"
          field="checked"
          align="center"
          width="60"
        ></vxe-table-column> -->
        <!-- <vxe-table-column field="aboutAmount" title="关联金额" width="150">
          <template v-slot="scope">
            <vxe-input
              v-model="scope.row.aboutAmount"
              placeholder="输入关联金额"
              v-on:input="inputAboutAmount(scope.row)"
              @input="$refs.xTable.updateStatus(scope)"
              v-if="scope.row.checked == true"
              type="number"
            ></vxe-input>
          </template>
        </vxe-table-column> -->
        <vxe-table-column
            field="ordersNumb"
            title="子订单编号"
            min-width="130"
        ></vxe-table-column>
        <vxe-table-column field="contractTitle" title="订单标题" min-width="120"></vxe-table-column>
        <vxe-table-column
            field="buyerName"
            title="托运人名称"
            min-width="200"
        ></vxe-table-column>
        <vxe-table-column
            field="sellerName"
            title="承运人名称"
            min-width="200"
        ></vxe-table-column>
        <!-- <vxe-table-column field="goodsName" title="货名" width="105">
          <template slot-scope="{ row, $rowIndex }">
            <div style="height: 24px">
              <div v-if="row.goodsRtnVos">{{ row.goodsName }}</div>
              <Icon
                  type="ios-arrow-down"
                  @click.stop="toggleGoods($rowIndex)"
                  v-if="row.goodsRtnVos && row.goodsRtnVos.length > 1"
              />
              <vxe-pulldown :ref="$rowIndex" placement="bottom" transfer>
                <template v-slot:dropdown>
                  <div class="my-dropdown3">
                    <vxe-table
                        auto-resize
                        :data="row.goodsRtnVos"
                        stripe
                        show-overflow
                        max-height="480"
                        align="center"
                    >
                      <vxe-table-column
                          field="goodsName"
                          title="货名"
                          width="104"
                      ></vxe-table-column>
                      <vxe-table-column
                          field="unit"
                          title="单位"
                          width="75"
                      ></vxe-table-column>
                      <vxe-table-column
                          field="counts"
                          title="数量"
                          width="75"
                      ></vxe-table-column>
                      <vxe-table-column
                          field="price"
                          title="单价"
                          width="75"
                      ></vxe-table-column>
                      <vxe-table-column field="isTax" title="含税" width="75">
                        <template slot-scope="{ row }">
                          <span>{{ row.isTax | taxMap }}</span>
                        </template>
                      </vxe-table-column>
                      <vxe-table-column
                          field="carShipNum"
                          title="车船号"
                          width="90"
                      ></vxe-table-column>
                      <vxe-table-column
                          field="beginPlace"
                          title="起运地"
                          width="90"
                      ></vxe-table-column>
                      <vxe-table-column
                          field="endPlace"
                          title="到达地"
                          width="90"
                      ></vxe-table-column>
                      <vxe-table-column
                          field="beginTime"
                          title="受载/起运时间"
                          width="140"
                      >
                        <template slot-scope="{ row }">
                          <span>{{ row.beginTime | timeFormatDate }}</span>
                        </template>
                      </vxe-table-column>
                    </vxe-table>
                  </div>
                </template>
              </vxe-pulldown>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="rule"
            title="规格"
            width="75"
        ></vxe-table-column>
        <vxe-table-column
            field="unit"
            title="单位"
            width="75"
        ></vxe-table-column>
        <vxe-table-column
            field="counts"
            title="数量"
            width="75"
        ></vxe-table-column>
        <vxe-table-column
            field="price"
            title="单价"
            width="75"
        ></vxe-table-column>
        <vxe-table-column field="isTax" title="含税" width="75">
          <template slot-scope="{ row }">
            <span>{{ row.isTax | taxMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="carShipNum"
            title="车船号"
            width="80"
        ></vxe-table-column>
        <vxe-table-column
            field="beginPlace"
            title="起运地"
            width="100"
        ></vxe-table-column>
        <vxe-table-column
            field="endPlace"
            title="到达地"
            width="100"
        ></vxe-table-column>
        <vxe-table-column field="beginTime" title="受载/起运时间" width="140">
          <template slot-scope="{ row }">
            <span>{{ row.beginTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column> -->
        <vxe-table-column
            field="createUser"
            title="创建人"
            min-width="100"
        ></vxe-table-column>
        <vxe-table-column field="createTime" title="创建日期" min-width="120">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div>
      <vxe-pager
          style="margin-top: 20px"
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
    <!-- <div class="footer-wrap" style="margin-bottom: 15px">
      <Button status="primary" @click="submit(true)">提交</Button>
      <div>
        <span>可关联金额为:</span> ¥
        <span style="color: blue">{{ payAmount }}</span>
      </div>
    </div> -->
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import {isEmpty, isNotEmpty} from "@/utils/util";
  import {numberToCurrency, numberToMoney} from "@/filters/type";

  export default {
    name: "PaymentAboutOrder",
    props: {
      isOnlyBuyer: Boolean
    },
    data() {
      return {
        type: 0, //  0 - 线上 ,  1 - 线下
        cate: "", // 选择的订单类型,  Collection 购买方订单  Payment SellerPayment 承运人订单
        platformCompanyId: "", //所属平台
        searchOrdersNum: "", //搜索订单号
        searchOrdersName: "", //搜索托运人 或 承运人 实际承运人 名称
        loading: false,
        payAmount: 0,
        tableData: [],
        isCheckboxAll: false,
        checkboxConfig: {
          labelField: "操作",
          checkField: "checked",
        },
        currentPage: 0,
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        },
        resMoneyMap: {},
        chainId: "",
        platformCompany: null,
      };
    },
    computed: {
      showCate() {
        return this.isOnlyBuyer ? false : true;
      }
    },
    // watch:{
    //   isOnlyBuyer(val) {
    //     console.log(val, 'val');
    //     if (val) {

    //       debugger
    //      this.changeCate('Collection')
    //     }
    //   }
    // },
    methods: {
      init(type, cate, paymentsId, payAmount, ordersList, chainId, platformCompany, platformCompanyId) {
        this.platformCompany = platformCompany;
        this.platformCompanyId = platformCompanyId;
        this.type = type;
        this.page.currentPage = 1;
        this.isCheckboxAll = false;
        this.cate = cate;
        if (this.isOnlyBuyer) {
          this.cate = 'Collection';
        }
        this.chainId = chainId;
        this.paymentsId = isEmpty(paymentsId) ? 0 : paymentsId;
        this.payAmount = payAmount;
        //   console.log(this.payAmount, "this.payAmount");
        this.ordersList = isEmpty(ordersList) ? [] : ordersList;

        this.searchOrdersNum = "";
        this.searchOrdersName = "";

        this.resMoneyMap = {};
        this.ordersList.forEach((item) => {
          if (isNotEmpty(item.ordersId)) {
            item.checked = true;
            this.resMoneyMap[item.ordersId] = item;
          }
        });

        this.getOrderList();
      },
      changeCate(name) {
        //   console.log(name, "name");
        //   console.log(this.paymentsId, "this.paymentsId,");
        //   console.log(this.ordersList, "changecate");
        //   console.log(this.payAmount, "xxxx.payAmount");
        //   console.log(this.platformCompanyId, "this.platformCompanyId");
        this.page.currentPage = 1;
        this.searchOrdersNum = "";
        this.searchOrdersName = "";
        this.cate = name;
        this.getOrderList();
        //   this.init(
        //     this.cate,
        //     this.paymentsId,
        //     this.payAmount,
        //     this.ordersList,
        //     this.platformCompanyId
        //   );
      },
      changePage(e) {
        // if (!this.submit()) {
        //   this.page.currentPage = this.currentPage === 0 ? 1 : this.currentPage;
        //   return;
        // }

        this.page.pageSize = e.pageSize;
        this.page.currentPage = e.currentPage;
        this.getOrderList();
        // if (this.currentPage != e.currentPage) {
        //   this.currentPage = e.currentPage;
        //   this.getOrderList();
        // }
      },
      search() {
        this.page.currentPage = 1;
        this.getOrderList();
      },
      async getOrderList() {
        // 获取列表数据
        this.loading = true;
        let pageRows;
        pageRows = (this.ordersList.length != 0 && this.paymentsId !== 0 && isEmpty(this.searchOrdersNum) && isEmpty(this.searchOrdersName)) ? this.ordersList.length : this.page.pageSize;
        let params = {
          paymentsId: this.paymentsId,
          chainId: this.chainId,
          page: this.page.currentPage,
          rows: pageRows,
          orderBy: 2,
        };
        if (this.cate == "Collection") {
          params.platformCompanyId = this.platformCompanyId
        } else  {
          params.buyerName = this.platformCompany
        } 
        // console.log(params, 'params');
        // debugger
        //搜索的参数
        if (this.searchOrdersNum) {
          if (this.cate == "Collection") {
            params.buyerOrdersNum = this.searchOrdersNum;
          } else {
            params.sellerOrdersNum = this.searchOrdersNum;
          }
        }
        if (this.searchOrdersName) {
          if (this.cate == "Collection") {
            params.buyerName = this.searchOrdersName;
          } else {
            params.sellerName = this.searchOrdersName;
          }
        }
        let res;
        if (this.cate == "Collection") {
          res = await $api.order.post("queryOrdersBuyerRelatedMoneyList", params);
        } else {
          params.isRealSeller = this.cate == "Payment" ? 0 : 1;
          res = await $api.sellerOrder.post(
            "queryOrdersSellerRelatedMoneyList",
            params
          );
        }

        if (res.status != 1) {
          if (isEmpty(res.message)) res.message = "接口异常";
          this.$refs.$XModal.message(res.mesage);
          return;
        }

        let tableData = res.data.rows;
        this.isCheckboxAll = true;

        tableData.map((i) => {
          if (this.cate == "Collection") {
            i.ordersNumb = i.buyerOrdersNum;
          } else {
            i.ordersNumb = i.sellerOrdersNum;
          }

          if (
            isNotEmpty(this.resMoneyMap[i.id]) &&
            this.resMoneyMap[i.id].aboutAmount > 0
          ) {
            i.relatedAmount = this.resMoneyMap[i.id].aboutAmount;
            i.aboutAmount = i.relatedAmount;
          } else {
            i.aboutAmount = null;
          }

          if (isEmpty(i.aboutAmount)) {
            i.checked = false;
            this.isCheckboxAll = false;
          } else {
            i.checked = true;
          }

          if (i.goodsRtnVos && i.goodsRtnVos.length > 0) {
            i.goodsName = i.goodsRtnVos[0].goodsName;
            i.rule = i.goodsRtnVos[0].rule;
            i.unit = i.goodsRtnVos[0].unit;
            i.counts = i.goodsRtnVos[0].counts;
            i.price = i.goodsRtnVos[0].price;
            i.isTax = i.goodsRtnVos[0].isTax;
            i.carShipNum = i.goodsRtnVos[0].carShipNum;
            i.beginPlace = i.goodsRtnVos[0].beginPlace;
            i.endPlace = i.goodsRtnVos[0].endPlace;
            i.beginTime = i.goodsRtnVos[0].beginTime;
            i.createTime = i.goodsRtnVos[0].createTime;
          }
        });
        this.tableData = tableData
        // if (isEmpty(this.ordersList) || this.paymentsId === 0 || isNotEmpty(this.searchOrdersName) || isNotEmpty(this.searchOrdersNum)) {
        //   this.tableData = tableData
        // } else {
        //   this.tableData = tableData.filter((i) => i.checked === true);
        // }
        
        this.page.totalResult = res.data.total;

        if (isNotEmpty(this.$refs.xTable)) {
          tableData.forEach((row) => {
            if (row.checked == true) {
              this.$refs.xTable.setCheckboxRow(row, true);
            }
          });
        }
        this.loading = false;
      },
      currentChangeEvent({row}) {
        // console.log(row, 1222);
        let resAmountList = [];
        let usedAmount = 0;
        let paymentType;
        if (this.cate == "Collection") {
          paymentType = 1;
        } else if (this.cate == "Payment") {
          paymentType = 2;
        } else {
          paymentType = 3;
        }
        let obj = {
          id: row.id,
          ordersId: row.id,
          ordersNumb: row.ordersNumb,
          chainNum: row.chainNum,
          buyerName: row.buyerName,
          buyerId: row.buyerId,
          sellerName: row.sellerName,
          sellerId: row.sellerId,
          salesMan: row.salesMan,
          salesManName: row.salesManName,
          rateManage: row.rateManage,
          platformCompany: row.platformCompany,
          platformCompanyId: row.platformCompanyId,
          paymentType,
        };
        resAmountList.push(obj);

        this.$emit("choose", resAmountList, usedAmount);
      },
      checkboxChange({row}) {
        row.checked = row.checked == true ? false : true;
        if (row.checked == false && isNotEmpty(this.resMoneyMap[row.id])) {
          delete this.resMoneyMap[row.id];
        }
        if (row.checked === false) {
          this.isCheckboxAll = false;
        }
      },
      checkBoxAll(e) {
        this.isCheckboxAll = this.isCheckboxAll == true ? false : true;
        this.tableData.forEach((item) => (item.checked = this.isCheckboxAll));
        if (this.isCheckboxAll == false) {
          this.tableData.forEach((item) => {
            item.aboutAmount = null;
            if (isNotEmpty(this.resMoneyMap[item.id])) {
              delete this.resMoneyMap[item.id];
            }
          });
        }
        this.$refs.xTable.updateStatus();
      },
      inputAboutAmount(row) {
        row.checked = true;
        this.resMoneyMap[row.id] = row;
      },
      toggleGoods(id) {
        this.$refs[id].togglePanel();
      },
      // submit(isSubmit) {
      //   let usedAmount = 0;
      //   let resAmountList = [];
      //   let paymentType;
      //   if (this.cate == "Collection") {
      //       paymentType = 1
      //   } else if (this.cate == "Payment"){
      //       paymentType = 2
      //   } else {
      //       paymentType = 3
      //   }
      //   //选中关联金额要填
      //   var errMsg = "";
      //   this.tableData.forEach((item) => {
      //     if (item.checked == true) {
      //       if (isEmpty(item.aboutAmount)) {
      //         errMsg = "请填写关联金额";
      //       } else if (isNaN(parseFloat(item.aboutAmount))) {
      //         errMsg = "关联金额错误";
      //       }
      //     }
      //   });

      //   if (isNotEmpty(errMsg)) {
      //     this.$XModal.message({ message: errMsg });
      //     return false;
      //   }

      //   //整理关联数据
      //   for (var ordersId in this.resMoneyMap) {
      //     let item = this.resMoneyMap[ordersId];
      //     if (item.checked == true) {
      //       if (isEmpty(item.aboutAmount) || item.aboutAmount == 0) {
      //         this.$XModal.message({ message: "请填写关联金额" });
      //         return false;
      //       } else {
      //         resAmountList.push({
      //           id: item.id,
      //           ordersId: ordersId,
      //           ordersNumb: item.ordersNumb,
      //           chainNum: item.chainNum,
      //           buyerName: item.buyerName,
      //           sellerName: item.sellerName,
      //           aboutAmount: parseFloat(item.aboutAmount),
      //           paymentType
      //         });

      //         usedAmount += parseFloat(item.aboutAmount);
      //       }
      //     }
      //   }
      //   if (parseInt(usedAmount * 100) > parseInt(this.payAmount * 100)) {
      //     let message =
      //       this.cate == "Collection"
      //         ? "关联金额不能超过收款金额"
      //         : "关联金额不能超过付款金额";
      //     this.$XModal.message({ message });
      //     return false;
      //   }
      //   if (usedAmount > 0) usedAmount = parseInt(usedAmount * 100) / 100;

      //   if (isSubmit) {
      //     this.$emit("choose", resAmountList, usedAmount);
      //   } else {
      //     return true;
      //   }
      // },
    },
  };
</script>

<style scoped>
  .vxe-pager .vxe-pager--wrapper {
    position: relative;
  }

  .vxe-pager .vxe-pager--sizes {
    height: 28px !important;
  }

  .modal-header {
    position: relative;
    height: 60px;
  }

  .my-search {
    padding: 10px;
    position: absolute;
    right: 0;
    top: 0;
  }

  .my-search .vxe-input {
    height: 34px;
    width: 400px;
  }

  .my-search .vxe-input >>> .vxe-input--suffix {
    display: block !important;
    width: 60px;
    height: 32px;
    top: 1px;
    text-align: center;
    border-left: 1px solid #dcdfe6;
    background-color: #f5f7fa;
    cursor: pointer;
  }

  .my-search .vxe-input >>> .vxe-input--inner {
    border: 1px solid #dcdfe6;
  }

  .btn-down {
    border: none;
    background: transparent;
  }

  .btn-down:focus {
    outline: none;
    border-color: transparent;
    box-shadow: none;
  }

  .link-text {
    margin-right: 30px;
    margin-left: 10px;
  }

  .ivu-btn.ivu-btn-primary {
    width: 140px;
    height: 40px;
  }
</style>